module.exports = __webpack_public_path__ + "static/frontUserNew/img/typeword.67e13e62.svg";